import Skeleton from '@material-ui/lab/Skeleton';
import TableSchedule, {TableScheduleProps} from '@tracker/shared/src/Scheduling/TableSchedule/TableSchedule';
import React, {useEffect, useState} from 'react';
import {useInView} from 'react-intersection-observer';

const VirtualTableSchedule : React.FC<TableScheduleProps> = (props : TableScheduleProps) => {
    const {ref, inView, entry} = useInView({delay: 100});
    const [fallbackHeight, setFallbackHeight] = useState(
        // Best guess of the actual resulting height.
        () => 33.5 * 3 + 61.5 + 43 * props.employeeSchedule.schedules.length
    );

    useEffect(() => {
        if (!entry || !inView) {
            return;
        }

        setFallbackHeight(entry.target.clientHeight);
    }, [entry, inView]);

    return (
        <div ref={ref}>
            {inView ? (
                <TableSchedule {...props}/>
            ) : (
                <Skeleton variant="rect" animation="wave" height={fallbackHeight}/>
            )}
        </div>
    );
};

export default VirtualTableSchedule;
